module.exports = __webpack_public_path__ + "assets/46a16eacb463ff11ad072c680978b1e8.png";